module.exports = __webpack_public_path__ + "static/media/amazon-dark.b178a57f.svg";